import React from "react";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";

import OtpSettings from "./OtpSettings";
import CompanyInfoSettings from "./CompanyInfoSettings";


const DEFAULT_TAB = 'company';
const VALID_TABS = ['company', 'otp'];

const GeneralSettings = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    const activeKey = VALID_TABS.includes(tabParam) ? tabParam : DEFAULT_TAB;

    const onTabChange = (key) => {
        setSearchParams(key === DEFAULT_TAB ? {} : { tab: key });
    };

    const tabItems = [
        {
            label: `Company Info`,
            key: 'company',
            children: <CompanyInfoSettings />,
        },
        {
            label: `One Time Password`,
            key: 'otp',
            children: <OtpSettings />,
        },
    ]
    return <Tabs
        tabPosition={'left'}
        activeKey={activeKey}
        onChange={onTabChange}
        items={tabItems}
    />
}

export default GeneralSettings;
